<span class="tw-relative tw-flex tw-items-center tw-justify-center">
  <span [class.tw-invisible]="showLoadingStyle()" class="tw-flex tw-items-center tw-gap-2">
    @if (startIcon()) {
      <i class="{{ startIconClasses() }}"></i>
    }
    <div>
      <ng-content></ng-content>
    </div>
    @if (endIcon()) {
      <i class="{{ endIconClasses() }}"></i>
    }
  </span>
  @if (showLoadingStyle()) {
    <span class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
      <bit-spinner [size]="spinnerSize()" />
    </span>
  }
</span>
